import gql from 'graphql-tag'

export const DOCTOR_FORGOT_PASSWORD = gql`
  mutation DOCTOR_FORGOT_PASSWORD($email: String!) {
    doctorResetPassword(email: $email)
  }
`
